module.exports = __webpack_public_path__ + "static/media/ConverseBrand.0e2fdd5f.svg";